import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { concatMap, map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as LocationAction from './actions';
import { LocationService } from "./service";
import { IServerResponse } from "app/interface";

@Injectable()
export class LocationEffect {

    constructor(
        private action: Actions,
        private locationService: LocationService
    ) { }

    GetLocationList = createEffect(() => this.action.pipe(
        ofType(type.GET_LOCATION_LIST),
        switchMap((data) => this.locationService.getLocationList()),
        map((data: Array<any>) => new LocationAction.LocationList(data)
        )
    ));

    SaveLocation = createEffect(() => this.action.pipe(
        ofType(type.SAVE_LOCATION),
        switchMap((data: any) => this.locationService.saveLocation(data.payload)),
        map((data: IServerResponse) => new LocationAction.SaveLocationResponse(data)
        )
    ));

    DeleteLocation = createEffect(() => this.action.pipe(
        ofType(type.DELETE_LOCATION),
        concatMap((data: any) => this.locationService.deleteLocation(data.payload)),
        map((data: IServerResponse) => new LocationAction.DeleteLocationResponse(data)
        )
    ));
}
